import { render, staticRenderFns } from "./newStudioSelection.vue?vue&type=template&id=89b92890&scoped=true"
import script from "./newStudioSelection.vue?vue&type=script&lang=js"
export * from "./newStudioSelection.vue?vue&type=script&lang=js"
import style0 from "./newStudioSelection.vue?vue&type=style&index=0&id=89b92890&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89b92890",
  null
  
)

export default component.exports